import React from 'react';
import { motion } from 'framer-motion';
import './colors.css';

const MainContent = ({ planeSize, viewportPosition, backgroundImage, userPosition, users, visibleUsers }) => {
  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden", position: "relative" }}>
      <div style={{ width: planeSize, height: planeSize, position: "absolute", top: -viewportPosition.y, left: -viewportPosition.x, border: "10px solid black", backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover" }}>
        <motion.div
          style={{
            position: "absolute",
            top: userPosition.y,
            left: userPosition.x,
            width: 20,
            height: 20,
            backgroundColor: "blue",
            borderRadius: "50%",
          }}
        />
        {users.map((user) => {
          const isVisible = visibleUsers.some(visibleUser => visibleUser.id === user.id);
          return (
            <motion.div
              key={user.id}
              style={{
                position: "absolute",
                top: user.y,
                left: user.x,
                width: 20,
                height: 20,
                backgroundColor: isVisible ? "red" : "brown",
                borderRadius: "50%",
              }}
            />
          );
        })}
      </div>
      <div style={{ position: "absolute", top: 10, left: "50%", transform: "translateX(-50%)", padding: "5px", color: "#FFD700", fontFamily: "'PressStart2P', sans-serif", fontSize: "10px" }}>
        <p>Use W, A, S, D keys or touch buttons to move</p>
      </div>
    </div>
  );
};

export default MainContent;